import { Tenant } from "./Types";

/** Pure resolver for tests and server-side reuse; pass `window.location.hostname` in the browser. */
export function resolveTenantFromHostname(hostname: string): Tenant {
	const h = hostname.toLowerCase();

	// Local development: hostname picks tenant (and thus Firestore DB routing on the server).
	if (h === "newleaf.localhost") {
		return Tenant.NEW_LEAF;
	}
	if (h === "cc-ca.localhost") {
		return Tenant.CONSOLIDATED_CREDIT_CANADA;
	}
	if (h === "cc-us.localhost") {
		return Tenant.CONSOLIDATED_CREDIT;
	}

	if (h.includes("newleaf")) {
		return Tenant.NEW_LEAF;
	}

	// Canadian Consolidated Credit sites: tenant drives the canada database (not a separate country dimension).
	if (h.endsWith(".ca") && !h.includes("newleaf")) {
		return Tenant.CONSOLIDATED_CREDIT_CANADA;
	}

	return Tenant.CONSOLIDATED_CREDIT;
}

export const resolveTenant = (): Tenant =>
	resolveTenantFromHostname(window.location.hostname);
